import { extends as _extends } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import React__default from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import tokens from '@te-digi/styleguide-tokens';
import { ModalContent } from './ModalContent.js';
import { ReactModalWrapper } from '../shared/ReactModalWrapper/ReactModalWrapper.js';
import { media } from '../utils/styles/media.js';

const StyledModal = styled(ReactModalWrapper).withConfig({
  componentId: "sg1510__sc-14in1yg-0"
})(["display:flex;justify-content:center;margin:0 auto;outline:0;padding:", ";pointer-events:none;position:relative;width:auto;", " ", "{padding:", ";}"], tokens.space.md, props => props.$centered && css(["align-items:center;min-height:100%;"]), media.sm, tokens.space.xl);
const Modal = _ref => {
  let {
    ariaLabelledby,
    centered,
    children,
    contentClassName,
    contentLabel,
    id,
    isOpen,
    onRequestClose,
    overlayClassName,
    shouldCloseOnOverlayClick,
    size,
    ...rest
  } = _ref;
  return /*#__PURE__*/React__default.createElement(StyledModal, _extends({}, rest, {
    $centered: centered,
    ariaLabelledby: ariaLabelledby,
    contentLabel: contentLabel,
    id: id,
    isOpen: isOpen,
    onRequestClose: onRequestClose,
    overlayClassName: overlayClassName,
    shouldCloseOnOverlayClick: shouldCloseOnOverlayClick
  }), /*#__PURE__*/React__default.createElement(ModalContent, {
    size: size,
    className: contentClassName
  }, children));
};
Modal.displayName = 'Modal';
Modal.propTypes = {
  /**
   * Label for assistive technology as id reference to an element that contains the label text. This should correspond to the id of <ModalHeading>
   */
  ariaLabelledby: PropTypes.string,
  centered: PropTypes.bool,
  /**
   * Content of the component. Usually <ModalHeader>,
   * <ModalBody> and <ModalFooter>.
   */
  children: PropTypes.node.isRequired,
  contentClassName: PropTypes.string,
  contentLabel: PropTypes.string,
  isOpen: PropTypes.bool.isRequired,
  onRequestClose: PropTypes.func,
  overlayClassName: PropTypes.string,
  shouldCloseOnOverlayClick: PropTypes.bool,
  size: PropTypes.oneOf(['sm', 'lg', 'xl'])
};

export { Modal };
